import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { darken, lighten } from 'polished'
import { Link } from 'gatsby'

export const CountdownSection = styled.div`
  display: ${(props) => (props.mobileOnly ? 'none' : 'block')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#790603')};
  width: 100%;
  padding: 40px;
  margin: ${(props) => (props.marginTop ? `40px 0px 0px 0px` : '-32px 0px 0px 0px')};
  @media (max-width: ${breakpoints.l}px) {
    margin: ${(props) => (props.marginTop ? `40px 0px 0px 0px` : '32px 0px 0px 0px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    display: block;
    margin-top: ${(props) => (props.marginTop ? `20px` : '0px')};
    padding: 32px;
  }
`
export const CountdownSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  column-gap: 140px;
  text-align: center;
  @media (max-width: ${breakpoints.l}px) {
    flex-direction: column;
    align-items: center;
    row-gap: 8px;
    width: 100%;
    padding: 0px;
  }
`
export const Header = styled.h2`
  font-family: 'MatterBold';
  font-size: 25px;
  letter-spacing: 2.5px;
  line-height: 140%;
  text-transform: uppercase;
  color: ${(props) => props.titleColor || '#fff'};
  margin: 0px;
  span {
    font-style: italic;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 20px;
    letter-spacing: 2px;
    margin-bottom: 0px;
  }
`
// TODO: Below is a temporary fix to ensure the secondary header is wide enough for MDay copy -- original max-width was 320px
export const SecondaryHeader = styled.p`
  max-width: 320px;
  font-family: 'MatterBold';
  text-align: center;
  font-size: 22px;
  line-height: 140%;
  margin-bottom: 10px;
  span {
    color: ${(props) => props.theme.coral};
  }
  @media (max-width: ${breakpoints.l}px) {
    margin: 16px auto;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    max-width: 205px;
  }
`
// TODO: Above is a temporary fix to ensure the secondary header is wide enough for MDay mobile copy -- original max-width was 220px

export const Time = styled.h3`
  font-family: 'MatterRegular';
  font-size: 48px;
  line-height: 140%;
  letter-spacing: 0.5px;
  color: ${(props) => props.color || props.theme.grayDark};
  margin: 0px;
  display: block;
  text-align: center;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 32px;
  }
  @media (max-width: 340px) {
    font-size: 28px;
  }
`
export const CountDownContainer = styled.div`
  margin: 0px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.s}px) {
    padding-top: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
`
export const Label = styled.p`
  font-family: 'MatterBold';
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 1.4px;
  margin: 0px;
  text-align: center;
  color: ${(props) => props.color || '#FFF'};
  @media (max-width: ${breakpoints.m}px) {
    font-family: 12px;
    line-height: 16px;
    letter-spacing: 1.2px;
  }
`
export const ColonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin-top: -20px;
  @media (max-width: 340px) {
    padding: 8px;
  }
`
export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
    margin-top: -24px;
  }
`
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const BuyNowContainer = styled.div`
  text-align: center;
  margin: 0px;
`
export const BuyNowLink = styled(Link)`
  display: inline-block;
  font-family: 'MatterRegular';
  background-color: ${(props) => props.bgColor};
  color: ${(props) => (props.color ? props.color : props.theme.grayDark)};
  text-decoration: none;
  line-height: 1.28;
  border-radius: 28px;
  border: none;
  font-size: 18px;
  padding: ${(props) => (props.big ? '12px 64px' : '10px 30px')};
  letter-spacing: 0.09px;
  margin-right: ${(props) => (props.marginRight ? '16px' : '0px')};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.bgColor)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.bgColor)}`};
  }
  @media (max-width: 850px) {
    width: 100%;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 0.08px;
    padding: ${(props) => (props.big ? '13px 64px' : '13px 20px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    background-color: transparent;
    color: ${(props) => props.theme.grayDark};
    text-decoration: underline;
    margin-bottom: -16px;
    font-family: 'MatterBold';
    ::after {
      content: '→';
      font-size: 1.2rem;
      text-decoration: underline;
    }
    &:hover {
      cursor: pointer;
      background-color: transparent;
      outline: none;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  /* @media (max-width: 365px) {
    font-size: 14px;
    padding: ${(props) => (props.big ? '13px 64px' : '13px 16px')};
  }
  @media (max-width: 340px) {
    padding: ${(props) => (props.big ? '13px 64px' : '13px 8px')};
  } */
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 4px;
  width: 70px;
  margin-top: 0px;
  @media (max-width: ${breakpoints.s}px) {
    width: 48px;
  }
`

export const CalNYCol = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  h1 {
    display: inline;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 60px;
  }
`
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 10px 10px 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${breakpoints.s}px) {
    padding: 5px 5px 0px 5px;
  }
`
export const CalNYLabel = styled(Label)`
  color: ${(props) => props.color};
  padding-top: 10px;
  font-family: 'P22MackinacPro';
  font-size: 14px;
  line-height: 19px;
  font-weight: 800;
`
export const HideOnMobile = styled.div`
  display: block;
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`
export const HideOnDesktop = styled.div`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`
export const DealHeadline = styled.p`
  font-size: 20px;
  color: ${(props) => props.theme.grayDark};
  font-family: 'MatterBold';
  text-align: center;
  span {
    color: #954341;
  }
`
export const DealCard = styled.div`
  margin-top: 16px;
`
export const DealContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  @media (max-width: ${breakpoints.s}px) {
    margin-top: -20px;
  }
`
export const DealTitle = styled.p`
  font-family: 'MatterBold';
  text-align: right;
  margin: 0px 5px 8px;
  color: ${(props) => props.theme.grayDark};
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
`
export const DealPrice = styled.p`
  text-decoration: line-through;
  text-align: right;
  margin: 0px 0px;
  color: ${(props) => props.theme.grayDark};
  span {
    color: #954341;
    font-family: MatterBold;
    text-decoration: none !important;
  }
`
export const ImageContainer = styled.div`
  min-width: ${(props) => (props.cal ? '350px' : '310px')};
  @media (max-width: 1450px) {
    min-width: 280px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    min-width: 250px;
    margin: auto;
  }
  @media (max-width: ${breakpoints.s}px) {
    min-width: 200px;
  }
`

export const AmazonFlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  // @media (max-width: ${breakpoints.l}px) {
  //   width: 400px;
  //   margin: auto;
  // }
  // @media (max-width: ${breakpoints.s}px) {
  //   display: block;
  //   max-width: 100%;
  // }
`
